<div class="container-fluid quote-print" #quotePrint>
	<ng-container *ngIf="quote_info">

		<div class="quote-header">
			<div class="quote-header-logo">
				<img [src]="rest.getImagePath(store?.ticket_image_id, rest.local_preferences.default_ticket_image_id)" alt="logo">
			</div>
			<div class="quote-header-info">
				<h2 class="company-name">{{(store?.business_name || billing_data?.razon_social) | uppercase}}</h2>
				<div *ngIf="store?.rfc || billing_data?.rfc" class="company-line">
					RFC {{(store?.rfc || billing_data?.rfc) | uppercase}}
				</div>
				<div class="company-line" *ngIf="store?.address || billing_data?.address">
					{{store?.address || billing_data?.address}}
				</div>
				<div class="company-line">
					<span *ngIf="store?.city || billing_data?.city">{{store?.city || billing_data?.city}}</span>
					<span *ngIf="store?.state || billing_data?.state">, {{store?.state || billing_data?.state}}</span>
					<span *ngIf="store?.zipcode || billing_data?.zipcode"> CP: {{store?.zipcode || billing_data?.zipcode}}</span>
				</div>
			</div>
			<div class="quote-header-folio">
				<div class="quote-title">Cotización</div>
				<div class="folio-row">
					<span class="folio-label">Folio :</span>
					<span class="folio-number">{{quote_info.quote.id}}</span>
				</div>
				<div class="emitted">
					<div class="emitted-label">Emitida</div>
					<div class="emitted-date">{{quote_info.quote.created | date: 'MMMM d, y' | uppercase}}.</div>
				</div>
				<div class="emitted" *ngIf="quote_info.quote.valid_until">
					<div class="emitted-label">Vigente hasta</div>
					<div class="emitted-date">{{quote_info.quote.valid_until | date: 'MMMM d, y' | uppercase}}.</div>
				</div>
				<table class="branch-info">
					<tr *ngIf="store?.name || store?.code">
						<th>Sucursal:</th>
						<td>{{(store?.name || store?.code) | uppercase}}</td>
					</tr>
				</table>
			</div>
		</div>

		<div class="c-row align-items-end mx-0 my-3 d-print-none">
			<div class="col">
				<h1 class="text-capitalize">Cotización</h1>
			</div>
			<div class="col-auto">
				<button type="button" class="btn btn-primary mx-1 m-3"	(click)="print($event)" title="Imprimir">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 28 28"><g _ngcontent-pvm-c245="" fill="none"><path _ngcontent-pvm-c245="" d="M7.004 5.765V7H6a4 4 0 0 0-4 4v7a3 3 0 0 0 3 3h2v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h2a3 3 0 0 0 3-3v-7a4 4 0 0 0-4-4h-1V5.752a2.75 2.75 0 0 0-2.754-2.75l-8.496.013a2.75 2.75 0 0 0-2.746 2.75zM19.5 5.752V7H8.504V5.765c0-.69.558-1.249 1.248-1.25l8.496-.013a1.25 1.25 0 0 1 1.252 1.25zM10 15.5h8a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 8.5 22v-5a1.5 1.5 0 0 1 1.5-1.5z" fill="currentColor"></path></g></svg>
				</button>

				<button (click)="startCreateOrderProcess()" class="btn btn-primary mx-1 my-3" *ngIf="!quote_info.order">
					<span style="position:relative; top:-2px;">
						<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16"><path fill="currentColor" d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM8.5 7v1.5H10a.5.5 0 0 1 0 1H8.5V11a.5.5 0 0 1-1 0V9.5H6a.5.5 0 0 1 0-1h1.5V7a.5.5 0 0 1 1 0z"/></svg>
					</span>
					<span class="d-none d-md-inline">Crear Orden</span>
				</button>

				<button (click)="showSendQuote()" class="btn btn-primary mx-1 my-3">
					<span style="position:relative; top:-2px;">
						<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="m7.172 11.334l2.83 1.935l2.728-1.882l6.115 6.033c-.161.052-.333.08-.512.08H1.667c-.22 0-.43-.043-.623-.12l6.128-6.046ZM20 6.376v9.457c0 .247-.054.481-.15.692l-5.994-5.914L20 6.376ZM0 6.429l6.042 4.132l-5.936 5.858A1.663 1.663 0 0 1 0 15.833V6.43ZM18.333 2.5c.92 0 1.667.746 1.667 1.667v.586L9.998 11.648L0 4.81v-.643C0 3.247.746 2.5 1.667 2.5h16.666Z"/></svg>
					</span>
					<span class="d-none d-md-inline">Enviar</span>
				</button>

				<button (click)="designCustomQuote()" class="btn btn-primary mx-1 my-3">
					<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="m19.3 8.925l-4.25-4.2l1.4-1.4q.575-.575 1.413-.575t1.412.575l1.4 1.4q.575.575.6 1.388t-.55 1.387L19.3 8.925ZM17.85 10.4L7.25 21H3v-4.25l10.6-10.6l4.25 4.25Z"/></svg>
					<span class="d-none d-md-inline ms-1">Diseñar PDF Comercial</span>
				</button>

				<a class="btn btn-primary mx-1 my-3" *ngIf="quote_info.order && quote_info?.order?.status != 'CLOSED'" [routerLink]="['/pos',quote_info.order.id]">
					<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><g fill="currentColor"><path d="M8.25 10.875a2.625 2.625 0 1 1 5.25 0a2.625 2.625 0 0 1-5.25 0Z"/><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.125 4.5a4.125 4.125 0 1 0 2.338 7.524l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007a4.125 4.125 0 0 0-3.399-6.463Z" clip-rule="evenodd"/></g></svg>
					Ver Orden
				</a>

				<a class="btn btn-primary mx-1 my-3" *ngIf="quote_info.order && quote_info?.order.status == 'CLOSED'" [routerLink]="['/view-order',quote_info.order.id]">
					<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><g fill="currentColor"><path d="M8.25 10.875a2.625 2.625 0 1 1 5.25 0a2.625 2.625 0 0 1-5.25 0Z"/><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75s9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.125 4.5a4.125 4.125 0 1 0 2.338 7.524l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007a4.125 4.125 0 0 0-3.399-6.463Z" clip-rule="evenodd"/></g></svg>
					Ver Orden
				</a>
				<a class="btn btn-primary mx-1 my-3" *ngIf="quote_info?.order" [routerLink]="['/print-remission',quote_info?.order.id]">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 28 28"><g _ngcontent-pvm-c245="" fill="none"><path _ngcontent-pvm-c245="" d="M7.004 5.765V7H6a4 4 0 0 0-4 4v7a3 3 0 0 0 3 3h2v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1h2a3 3 0 0 0 3-3v-7a4 4 0 0 0-4-4h-1V5.752a2.75 2.75 0 0 0-2.754-2.75l-8.496.013a2.75 2.75 0 0 0-2.746 2.75zM19.5 5.752V7H8.504V5.765c0-.69.558-1.249 1.248-1.25l8.496-.013a1.25 1.25 0 0 1 1.252 1.25zM10 15.5h8a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 8.5 22v-5a1.5 1.5 0 0 1 1.5-1.5z" fill="currentColor"></path></g></svg>
					Remision
				</a>
			</div>
		</div>

		<div class="quote-section-label">Cotizado a:</div>
		<div class="quote-client-name">
			{{(billing_address?.name || quote_info?.client_user?.name || quote_info.quote.name) | uppercase}}
		</div>
		<div class="quote-client-contact" *ngIf="quote_info.quote.phone || quote_info?.client_user?.phone">
			Contacto : {{quote_info.quote.phone || quote_info?.client_user?.phone}}
		</div>
		<div class="quote-client-contact" *ngIf="quote_info.quote.email || billing_address?.email || quote_info?.client_user?.email">
			Correo : {{(quote_info.quote.email || billing_address?.email || quote_info?.client_user?.email) | lowercase}}
		</div>

		<div class="quote-intro">A continuación pongo a su consideración la siguiente cotización:</div>

		<div class="quote-section-label" *ngIf="quote_info.quote.note">Otros Datos</div>
		<div class="quote-note" *ngIf="quote_info.quote.note">{{quote_info.quote.note}}</div>

		<div class="quote-items-wrap">
			<table class="quote-items-table">
				<thead>
					<tr>
						<th class="text-end col-cant">Cant.</th>
						<th class="col-unit">Unid.</th>
						<th class="col-clave">Clave</th>
						<th class="col-desc">Descripción</th>
						<th class="text-end col-price">P.Unitario</th>
						<th class="text-end col-importe">Importe</th>
						<th class="col-mon">Mon</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let quote_item_info of quote_info.items">
						<td class="text-end" data-label="Cantidad">{{quote_item_info.quote_item.qty | number:'1.2-2'}}</td>
						<td data-label="Unidad">{{(quote_item_info.item.measurement_unit || 'PIEZA') | uppercase}}</td>
						<td class="cell-clave" data-label="Clave">{{quote_item_info.item.code}}</td>
						<td class="cell-desc">
							{{quote_item_info.item.name | uppercase}}
							<button *ngIf="quote_item_info.item.batch_option !== 'NONE'" class="btn btn-sm btn-primary ms-1 d-print-none" (click)="viewBatches(quote_item_info)" title="Ver lotes/caducidades" type="button">
								<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M8.186 1.113a1.5 1.5 0 0 0-1.372 0L1.2 3.866a1.5 1.5 0 0 0-.72 1.354v5.56a1.5 1.5 0 0 0 .72 1.354l5.614 2.753a1.5 1.5 0 0 0 1.372 0l5.614-2.753a1.5 1.5 0 0 0 .72-1.354v-5.56a1.5 1.5 0 0 0-.72-1.354L8.186 1.113zm1.1 1.6 5.492 2.693-2.2 1.08-5.56-2.77 2.268-1.003zM3.3 5.734l5.555 2.775-2.108 1.034-5.6-2.8L3.3 5.734zm6.012 1.002 2.08-1.02 3.4 1.668v4.43l-5.48 2.687V6.736z"/></svg>
							</button>
							<app-item-info-button [item_id]="quote_item_info.item.id" [btn_class]="'btn btn-sm btn-primary ms-1'"></app-item-info-button>
							<div *ngIf="quote_item_info.quote_item.note" class="item-note">Nota: {{quote_item_info.quote_item.note}}</div>
						</td>
						<td class="text-end" data-label="P. Unitario">{{quote_item_info.quote_item.unitary_price | number:'1.2-2'}}</td>
						<td class="text-end" data-label="Importe">{{quote_item_info.quote_item.unitary_price * quote_item_info.quote_item.qty | number:'1.2-2'}}</td>
						<td data-label="Moneda">{{quote_info.quote.currency_id === 'MXN' ? 'M.N.' : quote_info.quote.currency_id}}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="quote-totals-wrap">
			<table class="quote-totals-table">
				<tr>
					<th>Importe</th>
					<td class="text-end accent">{{subtotal | number:'1.2-2'}}</td>
					<td class="accent">{{quote_info.quote.currency_id === 'MXN' ? 'M.N.' : quote_info.quote.currency_id}}</td>
				</tr>
				<tr>
					<th>Subtotal</th>
					<td class="text-end accent">{{subtotal | number:'1.2-2'}}</td>
					<td class="accent">{{quote_info.quote.currency_id === 'MXN' ? 'M.N.' : quote_info.quote.currency_id}}</td>
				</tr>
				<tr *ngIf="total_tax > 0">
					<th>IVA</th>
					<td class="text-end accent">{{total_tax | number:'1.2-2'}}</td>
					<td class="accent">{{quote_info.quote.currency_id === 'MXN' ? 'M.N.' : quote_info.quote.currency_id}}</td>
				</tr>
				<tr class="total-row">
					<th>TOTAL</th>
					<td class="text-end accent">{{total | number:'1.2-2'}}</td>
					<td class="accent">{{quote_info.quote.currency_id === 'MXN' ? 'M.N.' : quote_info.quote.currency_id}}</td>
				</tr>
			</table>
			<div class="amount-letters">{{total_letra}} {{currency?.name | uppercase}}</div>
		</div>

		<ng-container *ngIf="rest.local_preferences.quote_agent_footer_enabled">
			<div class="quote-closing">Quedo a sus órdenes,</div>

			<table class="quote-agent-table" *ngIf="quote_info?.creator">
				<thead>
					<tr>
						<th>Agente de Venta</th>
						<th>Teléfono</th>
						<th>Email</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td data-label="Agente">{{quote_info.creator.name | uppercase}}</td>
						<td data-label="Teléfono">{{quote_info.creator.phone || quote_info.creator.job_phone}}</td>
						<td data-label="Email">{{quote_info.creator.email}}</td>
					</tr>
				</tbody>
			</table>
		</ng-container>

	</ng-container>
</div>
<app-modal [(show)]="show_resend_quote" [closable]="false">
	<div class="container-fluid">
		<h2>Reenviar cotización</h2>
		<form name="send_quote_form" (submit)="sendQuote($event)" ngNativeValidate>
			<app-loading [is_loading]="is_loading"></app-loading>
			<div class="c-row">
				<div class="col-12 col-md-6">
					<label>Correo Electrónico</label>
					<input type="text" name="quote_email" [(ngModel)]="resend_quote_email" class="form-control" required>
				</div>
			</div>
			<div class="c-row py-3">
				<div class="col-6">
					<button type="button" class="btn btn-primary w-100" (click)="show_resend_quote=false" [disabled]="is_loading">Cancelar</button>
				</div>
				<div class="col-6">
					<button type="submit" class="btn btn-primary w-100">Enviar</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<app-modal [(show)]="show_delivery_schedule" [closable]="false">
	<div class="p-3">
		<h2>Crear Orden</h2>
		<h3>Fecha de entrega</h3>
		<form (submit)="confirmDeliverySchedule()" ngNativeValidate>
			<div class="form-check mb-3">
				<input
					type="checkbox"
					class="form-check-input"
					id="deliver_immediately"
					name="deliver_immediately"
					[ngModel]="deliver_immediately"
					(ngModelChange)="onDeliverImmediatelyChange($event)">
				<label class="form-check-label" for="deliver_immediately">Inmediatamente</label>
			</div>
			<div class="form-group mb-3">
				<label>Fecha y hora de entrega</label>
				<input
					type="datetime-local"
					class="form-control"
					[(ngModel)]="delivery_schedule"
					name="delivery_schedule"
					[disabled]="deliver_immediately"
					[required]="!deliver_immediately">
			</div>
			<div class="form-check mb-3" *ngIf="quote_info?.quote?.client_user_id && rest.current_permission.add_credit_limit">
				<input
					type="checkbox"
					class="form-check-input"
					id="increase_credit_limit"
					name="increase_credit_limit"
					[(ngModel)]="increase_credit_limit">
				<label class="form-check-label" for="increase_credit_limit">Incrementar el límite de crédito</label>
			</div>
			<div class="row mt-4">
				<div class="col-6">
					<button type="button" class="btn btn-secondary w-100" (click)="cancelDeliverySchedule()">Cancelar</button>
				</div>
				<div class="col-6">
					<button type="submit" class="btn btn-primary w-100">Continuar</button>
				</div>
			</div>
		</form>
	</div>
</app-modal>

<app-modal [(show)]="show_installments" [closable]="false">
	<div class="p-3">
		<h3>Generar Mensualidades (Opcional)</h3>
		<div class="form-group mb-3">
			<label>Numero de mensualidades (0 para crédito normal)</label>
			<input type="number" class="form-control" [(ngModel)]="installment_months" name="installments_months">
		</div>
		<ng-container *ngIf="installment_months > 0">
			<div class="form-group mb-3">
				<label>Frecuencia</label>
				<select name="frequency" [(ngModel)]="frequency" class="form-control">
					<option value="WEEKLY">Semanal</option>
					<option value="2X_MONTHLY">Quincenal</option>
					<option value="MONTHLY">Mensual</option>
				</select>
			</div>
			<div class="form-group mb-3">
				<label>Fecha Primer Pago</label>
				<input type="date" class="form-control" [(ngModel)]="first_payment_date" name="first_payment_date">
			</div>
			<div class="form-group mb-3">
				<label>
					Redondear pagos a
					<span class="text-info ms-1" style="cursor:help"
						title="Redondea cada mensualidad hacia arriba a un múltiplo, para dejar pagos 'cerrados'.&#10;Ejemplo: si un pago da $333...&#10;• escribes 5  → $335&#10;• escribes 10 → $340&#10;Usa 1 para no redondear.">
						<svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" viewBox="0 0 24 24" style="vertical-align:-2px">
							<path fill="currentColor" d="M12 2a10 10 0 1 0 0 20a10 10 0 0 0 0-20m0 5a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 12 7m1 10h-2v-6h2z"/>
						</svg>
					</span>
				</label>
				<input type="number" class="form-control" [(ngModel)]="installment_round_amount" name="installments_amount" step="1" min="1" max="1000">
			</div>
		</ng-container>
		<div class="row mt-4">
			<div class="col-6">
				<button type="button" class="btn btn-secondary w-100" (click)="cancelInstallments()">Cancelar</button>
			</div>
			<div class="col-6">
				<button type="button" class="btn btn-primary w-100" (click)="confirmInstallments()">Continuar</button>
			</div>
		</div>
	</div>
</app-modal>

<app-modal [show]="show_batch_selection" [closable]="false">
	<div class="p-3" *ngIf="getCurrentBatchPending() as pending">
		<h2>Seleccionar Lotes para {{pending.quote_item_info.item.name | titlecase}}</h2>
		<p class="text-muted">Cantidad requerida: <strong>{{pending.quote_item_info.quote_item.qty}}</strong>
			<span *ngIf="batch_items_pending.length > 1"> — Artículo {{current_batch_item_index + 1}} de {{batch_items_pending.length}}</span>
		</p>

		<div *ngIf="is_loading" class="text-center my-3">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Cargando...</span>
			</div>
		</div>

		<div *ngIf="!is_loading">
			<table class="table table-bordered mt-3">
				<thead>
					<tr>
						<th>Lote</th>
						<th>Caducidad</th>
						<th class="text-end">Disponible</th>
						<th class="text-end">Cantidad</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let sel of pending.selections">
						<td class="align-middle" style="width:150px">{{sel.batch.batch || 'N/A'}}</td>
						<td class="align-middle" style="width:150px">{{sel.batch.expiration_date ? (sel.batch.expiration_date | date:'shortDate') : 'N/A'}}</td>
						<td class="align-middle text-end">{{sel.batch.qty}}</td>
						<td style="">
							<div class="input-group">
								<button class="btn btn-outline-secondary px-2" type="button" (click)="sel.qty = (sel.qty > 0 ? sel.qty - 1 : 0)">
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.5em" height="1.5em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1zM8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z" fill="currentColor"/></g></svg>
								</button>
								<input type="number" class="form-control text-center px-1" [(ngModel)]="sel.qty" min="0" [max]="sel.batch.qty" step="1">
								<button class="btn btn-outline-secondary px-2" type="button" (click)="sel.qty = (sel.qty < sel.batch.qty ? sel.qty + 1 : sel.batch.qty)">
									<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.5em" height="1.5em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1zm1 15a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3z" fill="currentColor"/></g></svg>
								</button>
							</div>
						</td>
					</tr>
					<tr *ngIf="pending.selections.length === 0">
						<td colspan="4" class="text-center">No hay lotes disponibles con cantidad positiva en esta sucursal.</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="row mt-4">
			<div class="col-6">
				<button type="button" class="btn btn-secondary w-100" (click)="onBatchCancel()">Cancelar</button>
			</div>
			<div class="col-6">
				<button type="button" class="btn btn-primary w-100" (click)="onBatchConfirm()" [disabled]="is_loading || pending.selections.length === 0">Confirmar</button>
			</div>
		</div>
	</div>
</app-modal>

<app-modal [(show)]="show_view_batches" [closable]="true">
	<div class="p-3">
		<h2>Lotes y Caducidades disponibles</h2>
		<div *ngIf="view_batches_loading" class="text-center my-3">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Cargando...</span>
			</div>
		</div>
		<div *ngIf="!view_batches_loading">
			<table class="table table-bordered mt-3">
				<thead>
					<tr>
						<th>Lote</th>
						<th>Caducidad</th>
						<th class="text-end">Disponible</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let batch of view_batches_list">
						<td class="align-middle">{{batch.batch || 'N/A'}}</td>
						<td class="align-middle">{{batch.expiration_date ? (batch.expiration_date | date:'shortDate') : 'N/A'}}</td>
						<td class="align-middle text-end">{{batch.qty}}</td>
					</tr>
					<tr *ngIf="view_batches_list.length === 0">
						<td colspan="3" class="text-center">No hay lotes disponibles en la sucursal actual.</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row mt-4">
			<div class="col-12 text-end">
				<button type="button" class="btn btn-secondary" (click)="show_view_batches=false">Cerrar</button>
			</div>
		</div>
	</div>
</app-modal>
